import { ReactElement } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BRAND } from 'shared/Constants';

const AutheLayoutLeftPanel = (): ReactElement => (
  <Box className="auth-full-background">
    <Box className="left-panel">
      <Stack
        className="bg-image p-10"
        style={{
          backgroundImage: `url("/images/brand/authbg.svg")`,
        }}
        justifyContent="space-between"
      >
        <img width={200} src={BRAND.LOGO} />

        <Typography variant="h2" className="title">
          Govern AI
          <br />
          with Confidence.
          <br />
          Deploy with <span className="text-primary">Clarity.</span>
        </Typography>
      </Stack>
    </Box>
  </Box>
);

export default AutheLayoutLeftPanel;
